'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailValidator = undefined;

var _reactIntl = require('react-intl');

var _regexes = require('constants/regexes');

var _verify = require('helpers/verify');

var messages = (0, _reactIntl.defineMessages)({
  invalidEmail: {
    id: 'validators.email.invalid',
    defaultMessage: 'Please provide a valid email.'
  }
});

var emailValidator = exports.emailValidator = function emailValidator(email) {
  return !(0, _verify.isBlank)(email) && !_regexes.EMAIL_REGEX.test(email) && messages.invalidEmail;
};